// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ellyr","content":"styles_content__1Rv6t","tableWrap":"styles_tableWrap__3Cscj"};